import * as Ajax from '../ajax/Ajax';
import "../models/organization/OrganizationResultModel";
/**
 * 一覧を取得します。
 *
 * @param fn ファンクション
 */

export function Query(searchWord, startRow, pageSize, fn) {
  Ajax.Post("OrganizationApi/Query", {
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * Photon設定リストを取得します。
 *
 * @param fn ファンクション
 */

export function GetPhotonSettings(fn) {
  Ajax.Post("OrganizationApi/GetPhotonSettings", {}, Ajax.ModelResult(fn));
}
/**
 * 組織を追加します。
 *
 * @param organizationName 組織名
 * @param domain ドメイン
 * @param useEverywhere EVERYWHERE
 * @param useOneDrive OneDriveを使用可能かどうか
 * @param clientId クライアントID
 * @param entryContract 登録する契約
 * @param fn ファンクション
 */

export function AddOrganization(organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract, fn) {
  Ajax.Post("OrganizationApi/AddOrganizationWithoutId", {
    organizationName: organizationName,
    domain: domain,
    useEverywhere: useEverywhere,
    useOneDrive: useOneDrive,
    clientId: clientId,
    entryContract: entryContract
  }, Ajax.ModelResult(fn));
}
/**
 * 組織を更新します。
 *
 * @param organizationId 組織ＩＤ
 * @param organizationName 組織名
 * @param domain ドメイン
 * @param useEverywhere EVERYWHERE
 * @param useOneDrive OneDriveを使用可能かどうか
 * @param clientId クライアントID
 * @param entryContract 登録する契約
 * @param modifyContractList 編集した契約リスト
 * @param removeContractIdList
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyOrganization(organizationId, organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract, modifyContractList, removeContractIdList, updateDateTime, fn) {
  Ajax.Post("OrganizationApi/ModifyOrganization", {
    organizationId: organizationId,
    organizationName: organizationName,
    domain: domain,
    useEverywhere: useEverywhere,
    useOneDrive: useOneDrive,
    clientId: clientId,
    entryContract: entryContract,
    modifyContractList: modifyContractList,
    removeContractIdList: removeContractIdList,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 組織を削除します。
 *
 * @param organizationId 組織ＩＤ
 * @param organizationName 組織名
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteOrganization(organizationId, organizationName, updateDateTime, fn) {
  Ajax.Post("OrganizationApi/DeleteOrganization", {
    organizationId: organizationId,
    organizationName: organizationName,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 組織を変更します。
 *
 * @param organizationId 組織ＩＤ
 * @param organizationName 組織名
 * @param useWhiteroom WHITEROOM利用
 * @param useEverywhere EVERYWHERE利用
 * @param extentionFlg 拡張フラグ
 * @param fn ファンクション
 */

export function ChangeOrganization(organizationId, organizationName, useWhiteroom, useEverywhere, extentionFlg, fn) {
  Ajax.Post("OrganizationApi/ChangeOrganization", {
    organizationId: organizationId,
    organizationName: organizationName,
    useWhiteroom: useWhiteroom,
    useEverywhere: useEverywhere,
    extentionFlg: extentionFlg
  }, Ajax.ModelResult(fn));
}
/**
 * 組織を変更します。
 *
 * @param organizationId 組織ＩＤ
 * @param updateDateTime 更新日時
 * @param deleted 削除フラグ
 * @param fn ファンクション
 */

export function ChangeServiceStatus(organizationId, organizationName, deleted, updateDateTime, fn) {
  Ajax.Post("OrganizationApi/ChangeServiceStatus", {
    organizationId: organizationId,
    organizationName: organizationName,
    deleted: deleted,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 現在の拡張フラグを変更します。
 *
 * @param organizationId 組織ＩＤ
 * @param extentionFlg 拡張フラグ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ChangeActualExtentionFlg(organizationId, extentionFlg, updateDateTime, fn) {
  Ajax.Post("OrganizationApi/ChangeActualExtentionFlg", {
    organizationId: organizationId,
    extentionFlg: extentionFlg,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}